export default {
  editStoryheader: {
    id: 'EDIT-STORY-COMPANY-BACKGROUND_HEADER',
    defaultMessage: 'Company Background',
    description:
      'Campaigns > Story Kit > Story Edit Page: click on company background to edit, displays header',
  },
};
